import { appState } from '@/composable/appState';
import { reactive } from 'vue';
import MyAvailabilityDay from './MyAvailabilityDay';
export class MyAvailability {
    constructor(selectedUserTimezone) {
        this.isReady = false;
        this.selectedUserTimezone = appState.timeZone;
        this.dayWiseOpenMap = MyAvailability.DAYS.reduce((map, day) => {
            map[day.name] = false;
            return map;
        }, {});
        this.availableDays = reactive([]);
        this.basicDay = new MyAvailabilityDay('Sunday');
        if (selectedUserTimezone) {
            this.selectedUserTimezone = selectedUserTimezone;
        }
    }
    fillMissingDays(arr, setNonAvailableDays) {
        const days = [0, 1, 2, 3, 4, 5, 6];
        return days
            .filter(value => setNonAvailableDays &&
            !arr.some(item => item.daysOfTheWeek[0] === value))
            .map(value => ({
            daysOfTheWeek: [value],
            hours: [],
        }));
    }
    setOpenHoursDataFromDatabase(locationWiseOpenHours, setNonAvailableDays = true) {
        const newLocationWiseOpenHours = [
            ...locationWiseOpenHours,
            ...this.fillMissingDays(locationWiseOpenHours, setNonAvailableDays),
        ];
        this.availableDays.splice(0);
        newLocationWiseOpenHours.forEach(dayOpenHour => {
            var _a;
            if (!dayOpenHour.daysOfTheWeek.length) {
                return;
            }
            const dayOfWeek = dayOpenHour.daysOfTheWeek[0];
            const dayName = (_a = MyAvailability.DAYS.find(day => day.index === dayOfWeek)) === null || _a === void 0 ? void 0 : _a.name;
            if (dayName) {
                this.dayWiseOpenMap[dayName] = true;
                this.availableDays.push(new MyAvailabilityDay(dayName, dayOpenHour.hours.map(x => ({
                    startTime: `${x.openHour}:${x.openMinute}`,
                    endTime: `${x.closeHour}:${x.closeMinute}`,
                }))));
            }
        });
        this.isReady = true;
    }
    getAvailableDaysCount() {
        return this.availableDays.filter(item => item.hours.length !== 0).length;
    }
    updateAvailabilityDay({ day, checked, copy, }) {
        const dayIndex = this.availableDays.findIndex(x => x.day === day.day);
        if (dayIndex !== -1) {
            if (checked) {
                this.availableDays[dayIndex].addNewAvailabilityHourWithStartTimeAndEndTime({
                    startTime: '8:0',
                    endTime: '17:0',
                    copy,
                });
            }
            else {
                this.availableDays[dayIndex].removeAllAvailabilityHour();
            }
        }
    }
    copyFromOneToMany(dayName, targetDays) {
        const sourceDay = this.availableDays.find(day => day.day === dayName);
        if (sourceDay) {
            targetDays.forEach(targetDayName => {
                const targetDay = this.availableDays.find(day => day.day === targetDayName);
                if (targetDay) {
                    targetDay.hours = [];
                    targetDay.hours = sourceDay.hours.map(hour => (Object.assign({}, hour)));
                }
            });
        }
    }
}
MyAvailability.DAYS = [
    { name: 'Sunday', index: 0 },
    { name: 'Monday', index: 1 },
    { name: 'Tuesday', index: 2 },
    { name: 'Wednesday', index: 3 },
    { name: 'Thursday', index: 4 },
    { name: 'Friday', index: 5 },
    { name: 'Saturday', index: 6 },
];
